import { nanoid } from 'nanoid'
import { type IAddTagCallingActionPayload } from 'entities/AICalling/api/types.ts'
import type { IAddTagContentData } from 'widgets/TemplateActions/ui/AddTagContent/AddTagContent.tsx'

export const createAddTagCallingAction = (
  data: IAddTagContentData,
  token_id?: string
): IAddTagCallingActionPayload => {
  return {
    action_type: 'add_tag',
    trigger_type: 'end_of_call',
    settings: {
      token_id: token_id ?? nanoid(),
      ...data,
    },
  }
}
